import { Link } from 'react-router-dom';
import { NewsCard } from '.';
import { useNewsList } from '../../misc/lib/news';
import routes from '../../misc/routes';
import './NewsList.scss';

const NewsList = () => {
  const news = useNewsList();

  return (
    <div className="app-news-list">
      { news.map((n, i) => (
        <Link key={ i } to={ routes.news.children.specificNews.path.replace(':id', n.id) }>
          <NewsCard { ...n } />
        </Link>
      )) }
    </div>
  );
};

export default NewsList;
